import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { GroupsService } from "../../../..";
import { StudentGroupsTableRefreshService } from "../../shared/student-groups-table-refresh.service";
import { GroupActionReleaseScheduleInsertRequest } from "./GroupActionReleaseScheduleInsertRequest";
import * as moment from "moment";

@Component({
	selector: "app-sgadd-release",
	templateUrl: "./sgadd-release.component.html",
	styleUrls: ["./sgadd-release.component.css"],
})
export class SGAddReleaseComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private GroupReleaseService: GroupsService,
		private refreshService: StudentGroupsTableRefreshService
	) {}

	ngOnInit(): void {
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.SelectedGroup = this.dialogConfig.data.SelectedGroup;
		this.user = this.dialogConfig.data.user;

		this.loadReleaseType();
		this.loadExcuse();

		this.GroupName = this.SelectedGroup.GroupName;
	}

	////////////////////////////////////
	// Data
	////////////////////////////////////

	SelectedPromptTypeID: any = 0;
	lstPromptType: any = [
		{
			ID: 0,
			Desc: "Automatically assigned to new group members",
		},
		{
			ID: 1,
			Desc: "Optional group action for new group members",
		},
	];

	SchoolID: any;
	SelectedGroup: any;
	user: any;

	GroupName: any;

	ReleaseTypeID: any;
	lstReleaseType: any = [];

	AdmitTime: Date = new Date();
	ReleaseTime: Date = new Date();
	StartDate: Date = new Date();
	EndDate: Date = new Date();

	OnlyShowPresent: any = false;

	ExcuseID: any;
	lstAllExcuse: any = [];
	lstExcuse: any = [];

	Comment: any = "";

	MonCheck: any = false;
	TueCheck: any = false;
	WedCheck: any = false;
	ThuCheck: any = false;
	FriCheck: any = false;
	SatCheck: any = false;
	SunCheck: any = false;

	lstGuardian: any = [];

	errorMessage: any = "";

	////////////////////////////////////

	////////////////////////////////////
	// Load Data
	////////////////////////////////////
	loadReleaseType() {
		var result = this.GroupReleaseService.ReleaseTypeGetList("");
		result.subscribe(
			(response) => {
				this.lstReleaseType = response;

				this.ReleaseTypeID = this.lstReleaseType[0].ReleaseTypeID;
			},
			(error) => {}
		);
	}

	loadExcuse() {
		var result = this.GroupReleaseService.ExcuseSelectList(this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstAllExcuse = response;

				if (this.OnlyShowPresent == true) {
					this.lstExcuse = this.lstAllExcuse.filter((excuse) => excuse.IsCountAsPresent == 1);
				} else {
					this.lstExcuse = this.lstAllExcuse;
				}

				this.ExcuseID = this.lstExcuse[0].ExcuseID;
			},
			(error) => {}
		);
	}
	////////////////////////////////////

	////////////////////////////////////
	// Buttons
	////////////////////////////////////
	onAdd() {
		this.errorMessage = "";

		//Error handling
		var fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY");

		//Different for Group Action
		var fATime = "1900-01-01 " + moment(this.AdmitTime).format("HH:mm") + ":00";
		var fRTime = "1900-01-01 " + moment(this.ReleaseTime).format("HH:mm") + ":00";

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Start Date Invalid";
			return;
		}
		if (String(feDate).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "End Date Invalid";
			return;
		}
		if (String(fATime).toLowerCase().indexOf("invalid") != -1 && this.EnableAdmitTime() == true) {
			this.errorMessage = "Admit Time Invalid";
			return;
		}
		if (String(fRTime).toLowerCase().indexOf("invalid") != -1 && this.EnableReleaseTime() == true) {
			this.errorMessage = "Release Time Invalid";
			return;
		}

		if (this.EnableAdmitTime() == true && this.EnableReleaseTime() == true && this.AdmitTime >= this.ReleaseTime) {
			this.errorMessage = "Admit Time cannot be >= Release Time";
			return;
		}

		//Call SP

		if (this.EnableAdmitTime() == false) {
			fATime = "NULL";
		}
		if (this.EnableReleaseTime() == false) {
			fRTime = "NULL";
		}

		let parms: GroupActionReleaseScheduleInsertRequest = {
			ApplicationItemID: "",
			GroupID: this.SelectedGroup.GroupID,
			ReleaseTypeID: this.ReleaseTypeID,
			ExcuseID: this.ExcuseID,
			StartDT: fsDate,
			EndDT: feDate,
			AdmitTime: fATime,
			ReleaseTime: fRTime,
			SchoolID: this.SchoolID,
			Comments: this.Comment,
			AdminPersonID: this.user.personID,
			DaySun: this.SunCheck == true ? 1 : 0,
			DayMon: this.MonCheck == true ? 1 : 0,
			DayTue: this.TueCheck == true ? 1 : 0,
			DayWed: this.WedCheck == true ? 1 : 0,
			DayThu: this.ThuCheck == true ? 1 : 0,
			DayFri: this.FriCheck == true ? 1 : 0,
			DaySat: this.SatCheck == true ? 1 : 0,
			PromptTypeID: this.SelectedPromptTypeID,
		};

		var result = this.GroupReleaseService.GroupActionReleaseScheduleInsert(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Group Release was added successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.refreshService.GroupActionRefreshChanged(moment(new Date()).format("MM/DD/YYYY HH:mm:ss"));
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add the Group Release",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	////////////////////////////////////

	////////////////////////////////////
	// Events
	////////////////////////////////////
	onShowPresentChange(val) {
		this.OnlyShowPresent = val;

		if (this.OnlyShowPresent == true) {
			this.lstExcuse = this.lstAllExcuse.filter((excuse) => excuse.IsCountAsPresent == 1);
		} else {
			this.lstExcuse = this.lstAllExcuse;
		}

		this.ExcuseID = this.lstExcuse[0].ExcuseID;
	}
	////////////////////////////////////

	////////////////////////////////////
	// Helpers
	////////////////////////////////////
	EnableAdmitTime() {
		//Late Arrival
		if (this.ReleaseTypeID == 1) {
			return true;
		}
		//Mid Day
		else if (this.ReleaseTypeID == 2) {
			return true;
		}
		//Early Release
		else if (this.ReleaseTypeID == 3) {
			return false;
		}
		//Full Day Release
		else if (this.ReleaseTypeID == 4) {
			return false;
		} else {
			return false;
		}
	}

	EnableReleaseTime() {
		//Late Arrival
		if (this.ReleaseTypeID == 1) {
			return false;
		}
		//Mid Day
		else if (this.ReleaseTypeID == 2) {
			return true;
		}
		//Early Release
		else if (this.ReleaseTypeID == 3) {
			return true;
		}
		//Full Day Release
		else if (this.ReleaseTypeID == 4) {
			return false;
		} else {
			return false;
		}
	}

	////////////////////////////////////
}
